<template>
  <el-dialog v-model="visiblePV" :before-close="handleClose" :fullscreen="true">
    <div class="content">
      <div class="content-caption">
        {{ exam.name }}
      </div>

      <div class="content-list">
        <div
          class="content-list-item"
          v-for="(item, index) in exam.examQuestions"
          :key="index"
        >
          <div class="content-list-item-content">
            <div class="content-list-item-content-title">
              <label class="content-list-item-content-title-order">{{
                index + 1
              }}</label>
              <label class="content-list-item-content-title-text">{{
                item.questionsList
              }}</label>
            </div>
            <div class="content-list-item-content-option">
              <template
                v-for="(op, index2) in item.examQuestionsOptions"
                :label="index2"
              >
                <el-radio
                  :class="{
                    'content-list-item-content-option-radio': true,
                  }"
                  :key="index2"
                  :label="op.optionsList"
                  v-model="item.Selectedlabel"
                  size="large"
                  v-if="item.type == 0"
                  disabled
                >
                  {{ op.optionsList }}
                </el-radio>
              </template>

              <el-checkbox-group v-model="item.checkedTrues">
                <template
                  v-for="(op, index2) in item.examQuestionsOptions"
                  :label="index2"
                >
                  <el-checkbox
                    :class="{
                      'content-list-item-content-option-radio': true,
                    }"
                    :key="index2"
                    :label="op.optionsList"
                    size="large"
                    v-if="item.type == 1"
                    disabled
                  />
                </template>
              </el-checkbox-group>
              <el-input
                :key="index2"
                class="content-left-abstract-input"
                :rows="3"
                type="textarea"
                v-if="item.type == 2"
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ref } from "vue";
// import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
import {
  GetExamInfoById,
  ModifyExamData,
  AddExamData,
} from "@api/Exam/ApiExam";
import { dateFormat } from "@/util/utils.js";

export default {
  name: "ExamEditPriview",
  data() {
    return {
      examResult: {},
      router: useRouter(),
      examResultInfo: {},
      exam: {
        type: "", //类型
        title: "", //标题
        paperIntroduction: "", //简介
        grade: 15,
        isOpen: false,
        id: 0,
        examQuestions: [],
      },
    };
  },
  props: {
    visiblePV: false,
  },
  methods: {
    getTime(time) {
      return dateFormat("YYYY-mm-dd HH:MM:SS",time);
    },
    getData() {
      let examResult = JSON.parse(localStorage.getItem("ExamEditPriview_ExamResult"));
      if(examResult){
        this.exam = JSON.parse(examResult);
      }
    },
    handleClose() {
      this.$emit("close-dialog");
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.spring {
  flex: 1;
}
:deep(.el-checkbox__input.is-checked .el-checkbox__inner),
:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: #0747a6;
  border-color: #0747a6;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label),
:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #0747a6;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  // overflow-y: scroll;
  margin-right: 8px;

  &-caption {
    font-size: 24px;
    font-weight: 500;
    color: #33404e;
    padding-bottom: 10px;
    border-bottom: 1px solid #d8dee8;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-info {
    background: #e4e4e4;
    border-radius: 2px 2px 2px 2px;
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 56px;
    padding: 0 10px;

    &-note {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #33404e;
    }
    &-time {
      padding-left: 20px;
    }
    &-grade {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #33404e;

      &-value {
        font-size: 16px;
        font-weight: 500;
        color: #f7971e;
      }
      &-result {
        font-size: 16px;
        font-weight: 500;
        color: #14a386;
        padding-left: 10px;
      }
    }
  }
  &-list {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    // overflow-y: scroll;

    &-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin: 6px 0;

      &-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        border-radius: 2px 2px 2px 2px;
        padding: 10px;

        &-title {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          padding-bottom: 5px;

          &-order {
            font-size: 10px;
            font-weight: 400;
            color: #ffffff;
            background: #0747a6;
            border-radius: 2px 2px 2px 2px;
            padding: 0 8px;
            display: flex;
            margin-right: 5px;
            height: 24px;
            line-height: 24px;
          }
          &-type {
            font-size: 10px;
            font-weight: 400;
            color: #0747a6;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #0747a6;
            padding: 0 5px;
            margin-right: 5px;
            height: 24px;
            line-height: 24px;
            box-sizing: border-box;
          }
          &-text {
            flex: 1;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            margin-right: 5px;
          }
          &-grade {
            width: 40px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #b8c2c8;
            font-size: 14px;
            font-weight: 400;
            color: #f7971e;
            text-align: center;
            margin-right: 2px;
            height: 24px;
            line-height: 24px;
            box-sizing: border-box;
          }
          &-unit {
            font-size: 12px;
            font-weight: 400;
            color: #24335a;
            height: 24px;
            line-height: 24px;
          }
        }
        &-option {
          display: flex;
          flex-direction: column;

          &-radio {
            display: block;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            padding: 10px;
          }

          &-error {
            display: block;
            :deep(.el-checkbox__input .el-checkbox__inner),
            :deep(.el-radio__input .el-radio__inner) {
              background-color: #fe6e6f;
              border-color: #fe6e6f;
            }
            :deep(.el-checkbox__input + .el-checkbox__label),
            :deep(.el-radio__input + .el-radio__label) {
              color: #fe6e6f;
            }
          }
        }
        &-oprate {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          padding-top: 10px;

          &-note {
            font-size: 12px;
            font-weight: 400;
            color: #24335a;
          }
          &-img {
            width: 16px;
            height: 16px;
            padding: 2px 5px;
          }
        }
      }
    }
  }
}
</style>